
import { customerServicePayloadType } from '../interface';
import { isApp } from '../utils/env';

// eslint-disable-next-line
declare var uni: any;

interface Props {
  payload: customerServicePayloadType;
}

export default {
  props: {
    payload: {
      type: Object as () => customerServicePayloadType,
      default: () => ({}),
    },
  },
  emits: ['sendMessage'],
  setup(props: Props) {
    const jumpProductCard = () => {
      if (window) {
        window.open(props.payload.content.url, '_blank');
      } else {
        uni && uni.navigateTo({ url: `/TUIKit/components/TUIChat/web-view?url=${props.payload.content.url}` });
      }
    };
    return {
      props,
      isApp,
      jumpProductCard,
    };
  },
};
